module.exports = __webpack_public_path__ + "static/media/carta_37.eed29552.jpg";